export default {
  empty: {
    title: {
      en: 'Your cart',
    },
    text: {
      en: 'Your cart is empty',
    },
  },
  default: {
    title: {
      en: 'Your cart total - {total}',
    },
    text: {
      en: 'Let’s review your cart...',
    },
  },
}
